export default __webpack_public_path__ + "static/media/RealEstate_Banner.cbe4fe25.svg";